// JS mirror of values from _variables.scss.
// Kept in sync manually. Avoids the fragile SCSS :export / ICSS pattern
// which broke across css-loader versions.

export const colors = {
  progressBar: '#76b8ef',
  links: '#ececec',
  linksActive: '#ececec',
  spinner: '#898989',
  warning: '#d03636',
  toastInfo: '#1d3f61',
  buttonPrimaryBg: '#1d3f61',
  buttonPrimaryText: '#ececec',
  buttonPrimarySpinner: '#ececec',
  headerBackground: '#104670',
};

export const app = {
  borderRadius: '10px',
  spacing: '1.25rem',
  headerHeight: '3.15rem',
  headerProgressHeight: '3px',
  disabledOpacity: '0.3',
};

export const breakpoints = {
  phoneSmall: 480,
  phone: 575,
  tablet: 768,
  desktop: 991,
  desktopLarge: 1200,
};
